import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { MembershipsQuery, LocationsQuery, getRichText } from '../../core'
import LocationsByState from '../../components/LocationsByState'

import './locations.scss'

const LocationsSection = ({ 
  data = {}, 
  context = {}, 
}) => {
  const { 
    display,
    theme,
    editableContent,
  } = data

  const { 
    id,
  } = context

  const sectionClass = classNames(
    "locations-section",
    theme && `theme-${theme}`
  )

  return (
    <section styleName={`${sectionClass}`}>
      <LocationsQuery
        render={({ data: { locations = [] } }) => {
          const locationsWithMembership = locations
            .filter(m => !m.hideFromPages)
            .filter(location => {
              return location.membershipOptions 
              && location.membershipOptions.find(option => option.id === id)
            })

          return (
            <MembershipsQuery
              render={({ data = {} }) => {
                const { locations } = data

                const customLocations = locationsWithMembership.length > 0
                  ? locationsWithMembership
                  : locations

                return (
                  <div styleName="locations">
                    {editableContent && <div styleName="editable-content">
                      {getRichText(editableContent)}
                    </div>}
                    <LocationsByState 
                      customLocations={customLocations} 
                      display={display} 
                      theme={theme}
                    />
                  </div>
                )
              }}
            />
          )
        }}
      />
    </section>
  )
}

LocationsSection.propTypes = {
  data: PropTypes.any.isRequired,
  context: PropTypes.any,
}

export default LocationsSection